import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Accordion } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import Sidebar from '../../../../Sidebar/Sidebar';
import AppLink from '../../../../../routing/helpers/AppLink';
import Translator from '../../../../components/helpers/Translator';
import RiskFilterSidebarBlock from './RiskFilterSidebarBlock';
import ControlFilterSidebarBlock from './ControlFilterSidebarBlock';
import LogFilterSidebarBlock from './LogFilterSidebarBlock';
import ActionPlanFilterSidebarBlock from './ActionPlanFilterSidebarBlock';

export default function TotalEnergiesRiskSidebar({ activeRoute }) {
  const { moduleBridgeHex } = useParams();
  const auth = useSelector((state) => state.auth);
  const permissionLevel = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.userBridge?.permissions?.level
  );

  return (
    <Sidebar>
      <img
        src={auth.user?.client?.logoUrl}
        className="img-fluid"
        alt={auth.user?.client?.name}
        title={auth.user?.client?.name}
      />
      <Accordion>
        <ul>
          {activeRoute === 'user_module_totalEnergiesRisk_risk_list' && (
            <RiskFilterSidebarBlock />
          )}
          {activeRoute === 'user_module_totalEnergiesRisk_control_list' && (
            <ControlFilterSidebarBlock />
          )}
          {activeRoute === 'user_module_totalEnergiesRisk_actionPlan_list' && (
            <ActionPlanFilterSidebarBlock />
          )}
          {activeRoute === 'user_module_totalEnergiesRisk_log_list' && (
            <LogFilterSidebarBlock />
          )}
          <li className="divider" />
          <li
            className={`${activeRoute === 'user_module_totalEnergiesRisk_risk_list'
                ? 'active'
                : ''
              }`}
          >
            <AppLink
              path="user_module_totalEnergiesRisk_risk_list"
              params={{
                moduleBridgeHex,
                page: 1,
                filtersHex: 0,
              }}
              className="p-0"
            >
              <span className="sidebar-element" title="Riesgos">
                <span className="sb-title">Riesgos</span>
              </span>
            </AppLink>
          </li>
          <li
            className={`${activeRoute === 'user_module_totalEnergiesRisk_control_list'
                ? 'active'
                : ''
              }`}
          >
            <AppLink
              path="user_module_totalEnergiesRisk_control_list"
              params={{
                moduleBridgeHex,
                page: 1,
                filtersHex: 0,
              }}
              className="p-0"
            >
              <span className="sidebar-element" title="Controles">
                <span className="sb-title">Controles</span>
              </span>
            </AppLink>
          </li>
          <li
            className={`${activeRoute === 'user_module_totalEnergiesRisk_actionPlan_list'
                ? 'active'
                : ''
              }`}
          >
            <AppLink
              path="user_module_totalEnergiesRisk_actionPlan_list"
              params={{
                moduleBridgeHex,
                page: 1,
                filtersHex: 0,
              }}
              className="p-0"
            >
              <span className="sidebar-element" title="Planes de acción">
                <span className="sb-title">Planes de acción</span>
              </span>
            </AppLink>
          </li>
          {permissionLevel === 0 && (
            <>
              <li
                className={`${activeRoute === 'user_module_totalEnergiesRisk_process_list'
                    ? 'active'
                    : ''
                  }`}
              >
                <AppLink
                  path="user_module_totalEnergiesRisk_process_list"
                  params={{
                    moduleBridgeHex,
                    page: 1,
                    filtersHex: 0,
                  }}
                  className="p-0"
                >
                  <span className="sidebar-element" title="Logs">
                    <span className="sb-title">Procesos</span>
                  </span>
                </AppLink>
              </li>
              <li
                className={`${activeRoute === 'user_module_totalEnergiesRisk_log_list'
                    ? 'active'
                    : ''
                  }`}
              >
                <AppLink
                  path="user_module_totalEnergiesRisk_log_list"
                  params={{
                    moduleBridgeHex,
                    page: 1,
                    filtersHex: 0,
                  }}
                  className="p-0"
                >
                  <span className="sidebar-element" title="Logs">
                    <span className="sb-title">Logs</span>
                  </span>
                </AppLink>
              </li>
            </>
          )}
        </ul>
      </Accordion>
    </Sidebar>
  );
}
